import _ from 'lodash';
import { Trans } from '@lingui/macro';
import { useFormContext } from 'react-hook-form';
import { MenuItem } from '@material-ui/core';
import FormSection from '../../form/FormSection';
import {
    AGENT_SNMP_COMMUNITY_VALUE_FIELD,
    AGENT_SNMP_ENABLED_FIELD,
    AGENT_SNMP_V3_ENABLED_FIELD,
    AGENT_SNMP_V3_USER_FIELD,
    AGENT_SNMP_V3_AUTH_CIPHER_FIELD,
    AGENT_SNMP_V3_AUTH_PASSWD_VALUE_FIELD,
    AGENT_SNMP_V3_PRIV_CIPHER_FIELD,
    AGENT_SNMP_V3_PRIV_PASSWD_VALUE_FIELD,
    AGENT_SNMP_V3_AUTH_CIPHER_OPTIONS,
    AGENT_SNMP_V3_PRIV_CIPHER_OPTIONS,
    AGENT_SNMP_TARGET_2KH_FIELD,
    AGENT_SNMP_TARGET_3KH_FIELD,
    AGENT_SNMP_TARGET_EDGE_FIELD,
    AGENT_SNMP_V3_TARGET_EDGE_FIELD,
} from './AgentSettingsConstants';
import NgpPasswordField from '../../form/NgpPasswordField';
import NgpToggle from '../../form/NgpToggle';
import NgpTextField from '../../form/NgpTextField';
import NgpSelect from '../../form/NgpSelect';
import { useDetailStyles } from './AgentSettingsStyles';
import { RowFlexLayout } from '../../layout';
import NgpCheckbox from '../../form/NgpCheckbox';

export default function AgentSnmp() {
    const classes = useDetailStyles();
    const { watch } = useFormContext();
    const snmpEnabled = watch(AGENT_SNMP_ENABLED_FIELD);
    const snmpV3Enabled = watch(AGENT_SNMP_V3_ENABLED_FIELD);
    const authCipher = watch(AGENT_SNMP_V3_AUTH_CIPHER_FIELD);
    const privCipher = watch(AGENT_SNMP_V3_PRIV_CIPHER_FIELD);

    return (
        <FormSection title={<Trans>SNMP Agent</Trans>}>
            <NgpToggle fieldName={AGENT_SNMP_ENABLED_FIELD} label={<Trans>Enable SNMP v2c Agent</Trans>} />
            {snmpEnabled === true && (
                <main>
                    <NgpPasswordField
                        fieldName={AGENT_SNMP_COMMUNITY_VALUE_FIELD}
                        label={<Trans>Community String</Trans>}
                        inputProps={{ size: 60, maxLength: 255 }}
                        required
                        togglePasswordVisibility
                    />
                    <RowFlexLayout>
                        <NgpCheckbox fieldName={AGENT_SNMP_TARGET_2KH_FIELD} label={<Trans>Apply on NP-2000H</Trans>} />
                        <NgpCheckbox fieldName={AGENT_SNMP_TARGET_3KH_FIELD} label={<Trans>Apply on NP-3000H</Trans>} />
                        <NgpCheckbox
                            fieldName={AGENT_SNMP_TARGET_EDGE_FIELD}
                            label={<Trans>Apply on ES-490/690/695/795</Trans>}
                        />
                    </RowFlexLayout>
                </main>
            )}
            <NgpToggle fieldName={AGENT_SNMP_V3_ENABLED_FIELD} label={<Trans>Enable SNMP v3 Agent</Trans>} />
            {snmpV3Enabled === true && (
                <main>
                    <NgpTextField
                        fieldName={AGENT_SNMP_V3_USER_FIELD}
                        label={<Trans>User Name</Trans>}
                        inputProps={{ size: 60, maxLength: 255 }}
                        required
                    />
                    <NgpSelect
                        fieldName={AGENT_SNMP_V3_AUTH_CIPHER_FIELD}
                        label={<Trans>Authentication Protocol</Trans>}
                        className={classes.agentSnmpSelection}
                    >
                        {
                            // net-snmp 5.9.1 supports: MD5|SHA|SHA-224|SHA-256|SHA-384|SHA-512, but 490 doesn't support all of them
                            _.map(AGENT_SNMP_V3_AUTH_CIPHER_OPTIONS.getPairs(), (item) => (
                                <MenuItem key={item.key} value={item.key}>
                                    {item.value}
                                </MenuItem>
                            ))
                        }
                    </NgpSelect>
                    {authCipher !== AGENT_SNMP_V3_AUTH_CIPHER_OPTIONS.None && (
                        <main>
                            <NgpPasswordField
                                fieldName={AGENT_SNMP_V3_AUTH_PASSWD_VALUE_FIELD}
                                label={<Trans>Authentication Password</Trans>}
                                inputProps={{ size: 60, maxLength: 255 }}
                                required
                                togglePasswordVisibility
                            />
                            <NgpSelect
                                fieldName={AGENT_SNMP_V3_PRIV_CIPHER_FIELD}
                                label={<Trans>Privacy Protocol</Trans>}
                                className={classes.agentSnmpSelection}
                            >
                                {_.map(AGENT_SNMP_V3_PRIV_CIPHER_OPTIONS.getPairs(), (item) => (
                                    <MenuItem key={item.key} value={item.key}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                            </NgpSelect>
                            {privCipher !== AGENT_SNMP_V3_PRIV_CIPHER_OPTIONS.None && (
                                <NgpPasswordField
                                    fieldName={AGENT_SNMP_V3_PRIV_PASSWD_VALUE_FIELD}
                                    label={<Trans>Privacy Password</Trans>}
                                    inputProps={{ size: 60, maxLength: 255 }}
                                    required
                                    togglePasswordVisibility
                                />
                            )}
                        </main>
                    )}
                    <RowFlexLayout>
                        <NgpCheckbox
                            fieldName={AGENT_SNMP_V3_TARGET_EDGE_FIELD}
                            label={<Trans>Apply on ES-490/690/695/795</Trans>}
                        />
                    </RowFlexLayout>
                </main>
            )}
        </FormSection>
    );
}
